export const REQUIRED_FIELD = "Campo obrigatório";
export const POSITIVE_FIELD = "Deve ser um valor positivo";
export const NUMBER_FIELD = "Deve ser um número";
export const EMAIL_FIELD = "Digite um email válido";
export const CHECKBOX_TERMOS = "É necessário concordar com os termos";
